module.exports = __webpack_public_path__ + "assets/single-page-icon.84686a0e.svg";